import {useRef, useEffect} from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/pagination';


export default function LaunchdeckImageCarousel({imageArray, isProcessing}) {
	const swiperRef = useRef(null)

	useEffect(() => {
		if (swiperRef.current && swiperRef.current.swiper) {
				swiperRef.current.swiper.allowTouchMove = !isProcessing; // Dynamically enable/disable swipe
				swiperRef.current.swiper.update(); // Ensure Swiper updates its settings
		}
}, [isProcessing]);

	if (Array.isArray(imageArray)) {
		return (
			<Swiper
			ref={swiperRef}
			className='mySwiper'
			pagination={{
				dynamicBullets: true,
			}}
			modules={[Pagination]}
			noSwiping={true} 
			style={{ 
				maxWidth: "100%",
				width: "100%",
				borderRadius: "0.5em"
			}}
		>
	
			{imageArray.map((item, index) => {
				return (
					<SwiperSlide key={index} className="swiper-slide"
					 style={{ width: "100%", maxWidth: "100%", height: "auto" }} // Adapts to parent container
					>
						<img
							src={item.url || item}
							alt={`subwidget-${index}`}
							style={{ maxHeight: "400px", width: "auto",  maxWidth: "100%", display: "block", margin: "0 auto",
								objectFit: "contain", // Prevents stretching
							 }}
							 draggable={false}
						/>
					</SwiperSlide>
				)
			})}
		</Swiper>
	
		)
	} else return null;

}
